import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px", textAlign: "center" }}>
        Days I <strong className="purple">Code</strong>
      </h1>
      <GitHubCalendar
        username="Gediontkd"
        blockSize={15}
        blockMargin={5}
        color="#c084f5"
        fontSize={16}
        style={{
          color: "white" // Ensure the text is visible
        }}
        theme={{
          level0: '#161b22',
          level1: '#0e4429',
          level2: '#006d32',
          level3: '#26a641',
          level4: '#39d353',
        }}
      />
    </Row>
  );
}

export default Github;